import { useTranslations } from "next-intl";
import { memo } from "react";
import { useFiltersList } from "@hooks/use-features";
import shouldHideFilterSectionInListingPage from "@utils/catalog-filters/shouldHideFilterSectionInListingPage";
import SectionButton from "./Elements/SectionButton";
import SectionContent from "./Elements/SectionContent";
import FilterCheckbox from "./Elements/FilterCheckbox";

const filterSectionKey = "seasons";

const SeasonsSection = memo(function SeasonsSection({
  seasonItems,
  refineSeason,
  listingPage,
  onClose,
  filterSectionOpened,
  setFilterSectionOpened,
}) {
  const t = useTranslations("catalog");

  const filtersList = useFiltersList();

  if (shouldHideFilterSectionInListingPage(listingPage, "seasons")) return null;
  if (seasonItems.length < 2) return null;

  const sectionTitle = t(`filters.section_titles.${filterSectionKey}`);

  function displaySeasonsFiltersOptions() {
    return filtersList.seasons.map((filter) => {
      const item = seasonItems.find((seasonItem) => seasonItem.value === filter);

      if (!item) return;

      return (
        <FilterCheckbox
          key={`filter-${filter}`}
          label={t(`filters.seasons.${filter}`)}
          filterType="seasons"
          filterSectionKey={filterSectionKey}
          item={item}
          refine={refineSeason}
        />
      );
    });
  }

  const checkedFilters = {
    seasons: seasonItems
      .filter((seasonItem) => seasonItem.isRefined)
      .map((seasonItem) => seasonItem.value),
  };

  return (
    <div>
      <SectionButton
        checkedFilters={checkedFilters}
        filterTypesToDisplay={["seasons"]}
        title={sectionTitle}
        onClick={() => setFilterSectionOpened(filterSectionKey)}
      />

      <SectionContent
        isOpen={filterSectionOpened === filterSectionKey}
        onClose={onClose}
        onGoBack={() => setFilterSectionOpened("")}
        title={sectionTitle}
      >
        {displaySeasonsFiltersOptions()}
      </SectionContent>
    </div>
  );
});

export default SeasonsSection;
